import { AxiosResponse } from 'axios';
import { useAxios } from '@/features/common/helpers/axios';
import { NotificationPrefType } from '../types';

const { axiosService } = useAxios();

export const getUserNotificationsPrefs = async (): Promise<NotificationPrefType[]> => {
  try {
    const response: AxiosResponse = await axiosService.get('/settings/notifications');
    return response.data;
  } catch (err) {
    return [];
  }
};

export const updateNotificationPref = async (
  name: string,
  isShow: boolean,
): Promise<NotificationPrefType | null> => {
  try {
    const response: AxiosResponse = await axiosService.put(
      `/settings/notifications/${name}`, {
        show: isShow,
      },
    );
    return response.data;
  } catch (err) {
    return null;
  }
};
